var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  _forEachInstanceProperty(map).call(map, function (value, key) {
    result[++index] = [key, value];
  });

  return result;
}

module.exports = mapToArray;